import React from 'react';
import NavBar from '@src/components/NavBar';
import PageFooter from '../Home/PageFooter';
import PorLandingPage from './PorLandingPage';
import styles from './index.module.scss';

export default () => {
  const onLogoClick = () => {
    window.location.href = '/';
  };

  return (
    <div className={styles.root}>
      <NavBar active={true} onLogoClick={onLogoClick} />
      <div className={styles.content}>
        <PorLandingPage />
      </div>
      <PageFooter />
    </div>
  );
};
